import React, { HTMLProps, RefObject, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import Chevron from './Chevron'
import { ChevronType, Direction } from '../utils/constants'
import { twMerge } from 'tailwind-merge'

interface ScrollLinkProps extends HTMLProps<HTMLButtonElement> {
  title: string
  scrollRef: RefObject<HTMLDivElement>
}

const ScrollLink = ({ title, scrollRef, className }: ScrollLinkProps) => {
    const [isHovered, setIsHovered] = useState(false)

    const onClick = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' })
        }
    }
    return (
        <button
            onClick={onClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            className={twMerge('relative', className)}
        >
            <div className='flex items-center'>
                <FormattedMessage id={title} tagName='h6' />
                <div className='flex flex-col fill-white'>
                    <Chevron direction={Direction.DOWN} className='mb-1' type={ChevronType.FULL} />
                    <Chevron direction={Direction.DOWN} type={ChevronType.FULL} />
                </div>
            </div>
            <div
                style={{ width: isHovered ? '100%' : '0' }}
                className={twMerge(
                    'h-0.5 absolute -bottom-1 transition-width transition-300 ease-out bg-white',
                )}
            />
        </button>
    )
}

export default ScrollLink
